import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import SiriusTable from '@lingxi-common-component/sirius-ui/Table';
import { getIn18Text } from 'api';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import styles from './index.module.scss';
const MailReadList = ({ item, readList = [], isLoadingReadList = false, forbid = false }) => {
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    const hasReadList = useMemo(() => {
        const isRead = item.status === 'read';
        if (!(item.result === 109 && isRead))
            return false;
        if (productVersionId === 'sirius')
            return true;
        if (productVersionId === 'ultimate') {
            return readList.some(item => item.inner);
        }
        return false;
    }, [item, productVersionId, readList]);
    const showReadList = useMemo(() => {
        if (productVersionId === 'sirius')
            return readList;
        if (productVersionId === 'ultimate')
            return readList.filter(item => item.inner);
        return [];
    }, [readList, productVersionId]);
    const getTableColumns = () => {
        const baseColumns = [
            {
                title: getIn18Text('LOCAL_TIME'),
                dataIndex: 'readTime',
                key: 'readTime',
                render: (text) => text || '--',
            },
            {
                title: getIn18Text('READER_LOCAL_TIME'),
                dataIndex: 'localReadTime',
                key: 'localReadTime',
                render: (text) => text || '--',
            },
        ];
        if (!process.env.BUILD_ISEDM)
            return baseColumns;
        return [
            ...baseColumns,
            {
                title: getIn18Text('READ_CITY'),
                dataIndex: 'location',
                key: 'location',
                ellipsis: true,
                render: value => value ? (React.createElement(Tooltip, { title: value },
                    React.createElement("div", { className: "u-item-readlist-item-location" }, value))) : ('--'),
            },
            {
                title: getIn18Text('IP_ADDRESS'),
                dataIndex: 'clientIp',
                key: 'clientIp',
                render: (text) => text || '--',
            },
        ];
    };
    if (!hasReadList || !(showReadList === null || showReadList === void 0 ? void 0 : showReadList.length) || forbid) {
        return null;
    }
    return (React.createElement("div", { className: styles.table },
        React.createElement(SiriusTable, { bordered: true, columns: getTableColumns(), loading: isLoadingReadList, dataSource: showReadList, pagination: false })));
};
export default MailReadList;
